module.exports = __webpack_public_path__ + "img/infp-selected.63b64bec.png";